// extracted by mini-css-extract-plugin
export default {"module":"quizOne_module__e4W2n","arrival":"quizOne_arrival__2rV3B"};